import { useCallback, useEffect, useState } from 'react';
import supabase, { isSupabaseConfigured } from '../supabase';

export default function usePublishedContent(table, order = 'created_at', limit) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  useEffect(() => {
    if (!isSupabaseConfigured) { setLoading(false); return; }
    const controller = new AbortController();
    let active = true;
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    setLoading(true);
    setError(false);
    async function load() {
      try {
        let query = supabase.from(table).select('*').eq('published', true).order(order, { ascending: order === 'order_index' });
        if (limit) query = query.limit(limit);
        const result = await query.abortSignal(controller.signal);
        if (result.error) throw result.error;
        if (active) setData(result.data || []);
      } catch {
        if (active) setError(true);
      } finally {
        window.clearTimeout(timeout);
        if (active) setLoading(false);
      }
    }
    load();
    return () => { active = false; window.clearTimeout(timeout); controller.abort(); };
  }, [table, order, limit, attempt]);
  return { data, loading, error, retry };
}
